<template>
    <div>
        <div v-if="!creating && !editing" class="row">
            <div class="col-6">
                <b-col sm="10" offset="2" class="p-0">
                    <h4>Dirigeants enregistrés</h4>
                    <b-alert :show="noChief" variant="secondary">
                        Aucun·e dirigeant·e n'a été saisi·e pour cette société
                    </b-alert>

                    <div>
                        <chief
                            v-for="chief in chiefs"
                            :key="'chief' + chief.id"
                            :item="chief"
                            :can-edit="false"
                            @chief-is-deleted="
                                $emit('pappers-chiefs-is-updated')
                            "
                        />
                    </div>
                </b-col>
            </div>
            <div class="col-6">
                <b-col sm="10" offset="2" class="p-0">
                    <h4>Dirigeants communiqués par Pappers</h4>
                    <b-alert :show="noPappersChief" variant="secondary">
                        Aucune donnée Pappers
                    </b-alert>
                    <div v-if="!loading">
                        <div v-if="!creating && !editing">
                            <pappers-chief
                                v-for="chief in pappersChiefs"
                                :key="'papperChief' + chief.id"
                                :item="chief"
                                :company="company"
                                @chief-is-stored="
                                    $emit('pappers-chiefs-is-updated')
                                "
                            />
                        </div>
                    </div>
                    <div v-else>
                        <b-card>
                            <loading />
                        </b-card>
                    </div>
                </b-col>
            </div>
        </div>

        <div v-if="personType === 'moral'">
            <moral-person-search v-if="searching" />
            <moral-person-create v-if="creating" />
            <moral-person-edit v-if="editing" />
        </div>

        <div v-if="personType === 'physical'">
            <physical-person-search v-if="searching" />
            <physical-person-create v-if="creating" />
            <physical-person-edit v-if="editing" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Chief from './Chief'
import MoralPersonSearch from '../moralPersons/MoralPersonSearch'
import PhysicalPersonSearch from '../physicalPersons/PhysicalPersonSearch'
import PhysicalPersonCreate from '../physicalPersons/PhysicalPersonCreate'
import PhysicalPersonEdit from '../physicalPersons/PhysicalPersonEdit'
import MoralPersonCreate from '../moralPersons/MoralPersonCreate'
import MoralPersonEdit from '../moralPersons/MoralPersonEdit'
import PappersChief from './PappersChief'
import loading from '../../../../common/components/loading'

export default {
    name: 'PappersChiefs',

    components: {
        PappersChief,
        MoralPersonSearch,
        MoralPersonCreate,
        MoralPersonEdit,
        PhysicalPersonSearch,
        PhysicalPersonCreate,
        PhysicalPersonEdit,
        Chief,
    },

    props: {
        company: null,
    },

    data() {
        return {
            loading: false,
        }
    },

    created() {
        this.$store.commit('legalVM/RESET_STATUS')
    },

    methods: {
        showSearch(type) {
            this.$store.commit('legalVM/SET_PERSON_TYPE', type)
            this.$store.commit('legalVM/SET_LINK_TYPE', 'chiefs')
            this.$store.commit('legalVM/SHOW_SEARCH')
        },

        showEdit() {
            this.$store.commit('legalVM/SET_LINK_TYPE', 'chiefs')
            this.$store.commit('legalVM/SHOW_EDIT')
        },

        resetKey() {
            this.key = Date.now()
        },

        async updatePappers() {
            this.loading = true
            this.pappers = {}
            try {
                await axios.put(
                    `/moralPersons/${this.company.main_moral_person_id}/pappers`
                )
                this.$emit('pappers-chiefs-is-updated')
                this.loading = false
                this.resetKey()
            } catch (error) {
                console.error(error)
            }
        },
    },

    computed: {
        ...mapState({
            editing: (state) => state.legalVM.editing,
            searching: (state) => state.legalVM.searching,
            creating: (state) => state.legalVM.creating,
            personType: (state) => state.legalVM.personType,
        }),

        chiefs() {
            return this.company.chiefs.data
        },

        noChief() {
            return this.chiefs.length === 0 && !this.searching && !this.editing
        },

        pappersChiefs() {
            return this.company.pappers_data.chiefs.filter(
                (item) => !item.is_auditor
            )
        },

        noPappersChief() {
            return (
                this.pappersChiefs.length === 0 &&
                !this.searching &&
                !this.editing
            )
        },
    },
}
</script>

<style scoped></style>
